import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BranchNativeInterface } from 'src/app/interfaces/brach-native.interface';

@Injectable({
  providedIn: 'root'
})
export class BranchIOService {

  #http = inject(HttpClient);

  #key = 'key_test_jo2ufX9wYClwt0RZC8FQXcjoCyiN3wW1';

  #base = 'https://api2.branch.io/v2/event/custom';

  #payload = {
    name: 'recarga_celular',
    customer_event_alias: 'recarga_celular/comprobante',
    user_data: {
      advertising_ids: {
        oaid: ''
      },
      developer_identity: 'user123',
      country: 'US',
      language: 'en',
      ip: '',
      local_ip: '',
      brand: 'LGE',
      model: '',
      os: '',
      os_version: '',
      environment: 'FULL_APP',
      app_version: '',
      screen_dpi: '',
      screen_height: '',
      screen_width: '',
      android_id: '',
      idfa: '',
      aaid: '',
      limit_ad_tracking: false,
    },
    custom_data: {
      userid: '',
      compania: '',
      monto: '',
    },
    metadata: {},
    branch_key: this.#key,
  }

  send(userid: string, compania: string, monto: string, native: BranchNativeInterface): Promise<any> {
    const data = { ...this.#payload };
    data.user_data = { ...data.user_data, ...native };
    data.custom_data = { userid, compania, monto };
    return firstValueFrom(this.#http.post(this.#base, data));
  }
}
